/* Libs */
import Segment from '@integrations/segment';

/**
 * -------------------------------------------------------------------------------------
 * Define the "event name" here, in TRACKING_TYPES
 */
export const TRACKING_TYPES = {
  default: 'webflow initiated click',
};

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 */

export const SegmentTrackingAction = {
  /* When is the upsell viewed */
  default({ event, properties }: { event: string; properties: Record<string, any> }, type: string) {
    const payload = {
      event,
      properties,
    };

    Segment.track(type, payload);
  },
};
